import React, { useEffect ,useState} from "react";
import {Empty,Button, Pagination,Badge } from "antd";
import { useNavigate } from "react-router-dom";
import useStatsStore from "../../../store/stats.store";

import TableDashBoard from "../../TableDashBoard";

import "../myDashboardPages.scss";
import Filter from "../../filter";

export default function MyDashBoardPositiveFeedbacks({currentView, cb}) {

  const {myDashConsolidatedStatsPositiveFeedback,getMyDashBoardConsolidatedStatsPositiveFeedbacks,myDashConsolidatedStatsPositiveFeedbackCount} = useStatsStore();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };  

  useEffect(() => {
    //getAllJds();
  }, []);

  const resumeSelectionList = [
    "Sr. No.",   
    "Client",
    "TA",
    "Job Title",
    "SPOC",
    "Assigned To",
    "Screen Select",
    "L0 Select",
    "L1 Select",
    "L2 Select",
    "Customer Select",
    "HR Select",
  ];



  const resumeSelectionData = myDashConsolidatedStatsPositiveFeedback?.feedbacks?.map((feedback, idx) => {
    return {
      id: idx + 1 + (pageSize *(currentPage-1)),    
      client_name: feedback?.client,
      ta_name: feedback?.ta,
      title: '['+feedback?.qhcompanyjid+'] '+feedback?.title,
      SPOC: feedback?.spoc,
      assigned_to: feedback?.assignedto,
      screen_selected: feedback?.numscreenselected===0?"-":feedback?.numscreenselected,
      selected_for_L0: feedback?.numl0===0?"-":feedback?.numl0,
      selected_for_L1: feedback?.numl1===0?"-":feedback?.numl1,
      selected_for_L2: feedback?.numl2===0?"-":feedback?.numl2,
      selected_for_customers: feedback?.numhr===0?"-":feedback?.numcustomer,
      selected_for_hr: feedback?.numhr===0?"-":feedback?.numhr,
    };
  });   
 
  return (
    <div className="myDashboard-wrapper">
      <Filter
        filtername = {"getMyDashBoardConsolidatedStats"}
        initDuration={"24"}
        initPrio={"All"}
        initJDStatus={"Active"}
        initClient={"All"}               
        enableDuration
        enablePriority
        enableJdStatus
        enableCustomers  
        enableTAs             
        handleFilter={cb}
        pageNo={currentPage}
        pageSize={pageSize}
        pageHandler = {setCurrentPage}  
      />      
      <div></div>

      {myDashConsolidatedStatsPositiveFeedback ? (
        <>
           {currentView==="Screen/Interview Selections"?
             <>
              <TableDashBoard
                isClickable={true}
                isJDPage={true}
                titleList={resumeSelectionList}
                data={resumeSelectionData}
              />             
             </>:<></>
           }                                                  
        </>
        
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}

       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={myDashConsolidatedStatsPositiveFeedbackCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />            
    </div>
  );
}
